import React, { useState, useEffect, useLayoutEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { validateEmail } from "utils";

// import { Avatar } from "@mui/material";
import { toast } from "react-hot-toast";
// import TeacherForm from "./Sections/AddStaff/TeacherForm";
// import EvaluatorForm from "./Sections/AddStaff/EvaluatorForm";
import { Input, Select, TextArea } from "components/Form/index";
import { Button } from "components/Button/Button";
// import ReactSelect from "react-select";

import useMuiButtonLoader from "hooks/useMuiButtonLoader";
// import { getUserTypes ,getDepartmentType,getSingleRegionStatebyid,getRegionStatesList,getTalukaListbyid} from "services/master";
// import VideoEditorForm from "./Sections/AddStaff/VideoEditorForm";
// import { addStaff } from "services/staff/staffController";
// import { encryptData } from "config/config";
// import useCookie from "hooks/useCookie";
// import { EditorState } from "draft-js";
import {
  addUser,
  getDistrictdropdownList,
  getStatedropdownList,
  getTalukadropdownList,
  getUserRoledropdownList,
} from "services/usermanagement";
import useFullPageLoader from "hooks/useFullPageLoader";
// import { getDistrictList } from "services/statemanagement";
// import ModeratorForm from "./Sections/AddStaff/ModeratorForm";
// import AffiliateAdmin from "./Sections/AddStaff/AffiliateAdmin";

export default function AddUser() {
  const navigate = useNavigate();
  // const { cookies } = useCookie();

  const [isValidEmail, setIsValidEmail] = useState(true);
  const [mobError, setMobError] = useState("");

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  // const [allUserType, setAllUserType] = useState([]);
  const [staffData, setStaffData] = useState({
    name: "",
    // userName: "",
    role: "",
    department: "",
    EmployeeCode: "",
    courseCategory: [],
    centerId: "",
    type: [],
    mobile: "",
    email: "",
    address: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    zipcode: "",
  });

  const [errorField, setErrorField] = useState({
    name: "",
    // userName: "",
    profile: "",
    role: "",
    department: "",
    EmployeeCode: "",
    courseCategory: "",
    centerId: "",
    type: "",
    mobile: "",
    email: "",
    address: "",
    state: "",
    district: "",
    taluka: "",
    city: "",
    zipcode: "",
  });

  // const [profileImage, setProfileImage] = useState("");

  const [allStates, setAllStates] = useState([]);
  const [allDistricts, setAllDistricts] = useState([]);
  const [allTalukas, setAllTalukas] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  // ****************************** Fetch All States *****************************************



  //*********************Handel Validation********************************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    // if (!profileImage) {
    //   errorField["profile"] = "Please Select Profile";
    //   formIsValid = false;
    // }
    if (!staffData.name) {
      errorField["name"] = "Please Enter Name";
      formIsValid = false;
    }

    if (!staffData.email) {
      errorField["email"] = "Please Enter Email";
      formIsValid = false;
    } else if (!validateEmail(staffData.email)) {
      errorField["email"] = "Please Enter Valid Email";
      formIsValid = false;
      setIsValidEmail(false);
    }

    if (!staffData.mobile) {
      errorField["mobile"] = "Please Enter Mobile No.";
      formIsValid = false;
    } else if (staffData.mobile.length !== 10) {
      errorField["mobiles"] = "Mobile number must be 10 digits";
      formIsValid = false;
    }
    //  else if (staffData.mobile.length !== 10) {
    //   errorField["mobiles"] = "Mobile number must be 10 digits";
    //   formIsValid = false;
    // }
    if (!staffData.city) {
      errorField["city"] = "Please Enter City";
      formIsValid = false;
    }
    if (!staffData.state) {
      errorField["state"] = "Please Select State";
      formIsValid = false;
    }
    if (!staffData.district) {
      errorField["district"] = "Please Select District";
      formIsValid = false;
    }
    if (!staffData.zipcode) {
      errorField["zipcode"] = "Please Enter Zipcode";
      formIsValid = false;
    }
    if (!staffData.address) {
      errorField["address"] = "Please Enter Address";
      formIsValid = false;
    }
    // if (!staffData.userName) {
    //   errorField["userName"] = "Please Enter User Name";
    //   formIsValid = false;
    // }

    setErrorField(errorField);
    return formIsValid;
  };

  //*********************Submit Staff Handler********************************** *//
  const submitStaff = async (e) => {
    e.preventDefault();
    if (handleValidation()) {
      setSubmitLoading(true);
      try {
        // const formData = new FormData();
        // const finalData = {
        //   FirstName: staffData.firstName,
        //   LastName: staffData.lastName,
        //   EmailID: staffData.email,
        //   UserName: staffData.userName,
        //   Mobile: staffData.mobile,
        //   Phone: staffData.mobile,
        //   Address: staffData.address,
        //   City: staffData.city,
        //   State: staffData.state, // Ensure state value is set
        //   ZipCode: staffData.zipcode,
        //   role_id: staffData.role,
        //   department_id: staffData.department,
        //   EmployeeCode: staffData.EmployeeCode,
        //   // state: staffData.state,
        //   district: staffData.district, // Ensure district value is set
        //   taluka: staffData.taluka, //
        //   worklocation: staffData.worklocation,
        // };

        // formData.append("image", profileImage);
        // formData.append(
        //   "reqData",
        //   encryptData({ ...finalData, access_token: cookies })
        // );
        const res = await addUser({
          Name: staffData.name,
          EmailID: staffData.email,
          Mobile: staffData.mobile,
          Address: staffData.address,
          City: staffData.city,
          State: staffData.state,
          ZipCode: staffData.zipcode,
          District: staffData.district,
        });
        if (res.code === 200) {
          toast.success(res.message);
          setSubmitLoading(false);
          navigate(-1);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    } else {
      toast.error("Please fill all the fields");
    }
  };

  //   onChange Handler
  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      setIsValidEmail(true);
    }
    if (name === "zipcode") {
      setStaffData({ ...staffData, [name]: value.replace(/\D/g, "") });
    } else if (name === "city" || name === "state") {
      setStaffData({
        ...staffData,
        [name]: value.replace(/[^A-Za-z ]/gi, "").replace(/\s+/g, " "),
      });
    } else if (name === "mobile") {
      // Mobile number validation
      const numericValue = value.replace(/\D/g, "");
      setStaffData({ ...staffData, [name]: numericValue });

      if (numericValue.length === 10) {
        setMobError("");
      } else {
        setMobError("Mobile number must be 10 digits");
      }
    } else {
      setStaffData({ ...staffData, [name]: value });
    }
  };


  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 col-xl-5 d-flex justify-content-between">
                <h4 className="Title">
                  <Link to={-1}>
                    <i className="fa fa-arrow-left"></i>
                  </Link>
                  Add User
                </h4>
              </div>
            </div>
            {loader}
            <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <form onSubmit={submitStaff}>
                  <div className="form-group row mt-1">
                    <div className="col-md-12 col-form-label order-1 d-flex flex-column justify-content-end">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="row">
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="name"
                                value={staffData.name}
                                onChange={onChangeHandler}
                                placeholder="Enter Name"
                                className={`form-control `}
                                maxLength={30}
                                label="Name"
                                error={errorField.name}
                                required
                              />
                            </div>


                            <div
                              htmlFor="email"
                              className="col-sm-6 col-form-label"
                            >
                              <Input
                                type="email"
                                name="email"
                                value={staffData.email}
                                onChange={onChangeHandler}
                                placeholder="Enter Email"
                                className={`form-control ${((!staffData.email && errorField.email) ||
                                    !isValidEmail) &&
                                  "is-invalid"
                                  }`}
                                maxLength={40}
                                label={"Email ID"}
                                error={errorField.email}
                                required
                              />
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="mobile"
                                value={staffData.mobile}
                                onChange={onChangeHandler}
                                maxLength={10}
                                placeholder="Enter Mobile"
                                className={`form-control ${mobError && "is-invalid"}`}
                                label={"Mobile"}
                                error={errorField.mobile}
                                required
                              />
                              {mobError && (
                                <span
                                  className="error"
                                  style={{
                                    color: "#dc3545",
                                    fontSize: "13px",
                                    marginLeft: "1px",
                                  }}
                                >
                                  {mobError}
                                </span>
                              )}
                            </div>
                            <div className="col-sm-6 col-form-label">
                              <Input
                                type="text"
                                name="state"
                                value={staffData.state}
                                onChange={onChangeHandler}
                                placeholder="Enter State"
                                className={`form-control `}
                                maxLength={40}
                                label={"State"}
                                error={errorField.state}
                                required
                              />
                            </div>
                          </div>
                        </div>


                        <div className="col-sm-6 col-form-label">
                          <Input
                            type="text"
                            name="district"
                            value={staffData.district}
                            onChange={onChangeHandler}
                            placeholder="Enter District"
                            className={`form-control `}
                            maxLength={40}
                            label={"District"}
                            error={errorField.district}
                            required
                          />
                        </div>

                        <div className="col-sm-6 col-form-label">
                          <Input
                            type="text"
                            name="city"
                            value={staffData.city}
                            onChange={onChangeHandler}
                            placeholder="Enter City"
                            className={`form-control `}
                            maxLength={40}
                            label={"City"}
                            error={errorField.city}
                            required
                          />
                        </div>
                        <div className="col-sm-4 col-form-label">
                          <Input
                            type="text"
                            name="zipcode"
                            placeholder="Enter Zipcode"
                            className={`form-control `}
                            value={staffData.zipcode}
                            onChange={onChangeHandler}
                            maxLength={6}
                            label={"Zipcode"}
                            error={errorField.zipcode}
                            required
                          />
                        </div>
                        <div className="col-sm-12 col-form-label">
                          <TextArea
                            type="text"
                            name="address"
                            value={staffData.address}
                            onChange={onChangeHandler}
                            placeholder="Enter Address"
                            className={`form-control `}
                            label="Address"
                            error={errorField.address}
                            rows={7}
                            required
                          />
                        </div>


                      </div>
                    </div>
                  </div>

                  <div className="text-center mt-4">
                    <Button type="submit" {...submitButtonElement}>
                      Add User
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
